import { useCallback, useContext, useEffect, useState } from 'react';
import { RemotionPlayerContext } from '../context/RemotionPlayerContext';

export const useRemotionPlayerPause = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { playerRef } = useContext(RemotionPlayerContext);

  useEffect(() => {
    if (playerRef) {
      const onPlayHandle = () => {
        setIsPlaying(true);
      };
      const onPauseHandle = () => {
        setIsPlaying(false);
      };
      playerRef.addEventListener('play', onPlayHandle);
      playerRef.addEventListener('pause', onPauseHandle);
      return () => {
        playerRef.removeEventListener('play', onPlayHandle);
        playerRef.removeEventListener('pause', onPauseHandle);
      };
    }
  }, [playerRef]);

  const play = useCallback(() => {
    playerRef?.play();
  }, [playerRef]);

  const pause = useCallback(() => {
    playerRef?.pause();
  }, [playerRef]);

  return { isPlaying, play, pause };
};
